import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import FlowTask from "./FlowTask";

const useStylesTasks = makeStyles((theme) => ({
    formControlTasksTitleContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    formControlTasksTitle: {
        marginRight: "20px",
    },
    root: {
        display: "flex",
        flexDirection: "column",
        paddingTop: "24px",
    },
    action: {
        width: "24px",
        height: "24px",
        padding: "0",
        minWidth: "24px",
        minHeight: "24px",
    },
    actionIcon: {
        marginLeft: "8px",
    },
}));

export default function FlowTasks({ tasks = [], settingsFlow, mode, setFormInitialValues, setFormDialogProps, onChangeOrdinal, users }) {
    const classesTasks = useStylesTasks();
    const [overTask, setOverTask] = useState(undefined);
    const readOnly = mode === "detail";

    function getUserByEmail(email) {
        return users.find(x => x.email === email);
    }

    function onEditHandler(task) {
        setFormInitialValues({
            ...task,
            notifyBeforeDueDateUsers: task.notifyBeforeDueDateConfig
                ? JSON.parse(task.notifyBeforeDueDateConfig).mailsTo.map(getUserByEmail)
                : [],
        });
        setFormDialogProps((prev) => ({ ...prev, open: true, action: "update", title: "Update task" }));
    }

    function onAddHandler() {
        setFormInitialValues({
            name: "",
            description: "",
            initialStatus: "",
            defaultAssigneeUser: null,
            dueUnitQty: 0,
            dueUnit: "",
            allowAssigneeReassign: settingsFlow.allowAssigneesReassign,
            waitForPreviousTask: false,
            notifyClientOnClose: false,
            notifyBeforeDueDate: false,
            notifyBeforeDueDateInterval: 2,
            notifyBeforeDueDateTimeUnit: "d",
            notifyBeforeDueDateUsers: [],
        });
        setFormDialogProps((prev) => ({ ...prev, open: true, action: "add", title: "Add task" }));
    }

    function onViewHandler(task) {
        setFormInitialValues({
            ...task,
            notifyBeforeDueDateUsers: task.notifyBeforeDueDateConfig
                ? JSON.parse(task.notifyBeforeDueDateConfig).mailsTo.map(getUserByEmail)
                : [],
        });
        setFormDialogProps((prev) => ({ ...prev, open: true, action: "detail", title: "Task" }));
    }

    function onMoveUpHandler(task) {
        onChangeOrdinal(task, "up");
    }

    function onMoveDownHandler(task) {
        onChangeOrdinal(task, "down");
    }

    if (mode === "add") {
        return <></>;
    }

    return (
        <>
            <div className={classesTasks.formControlTasksTitleContainer}>
                <small className={classesTasks.formControlTasksTitle}>Tasks</small>
                {mode === "update" && (
                    <Button
                        title="Add new task"
                        variant="text"
                        size="small"
                        color="primary"
                        startIcon={<AddIcon className={classesTasks.actionIcon} />}
                        className={classesTasks.action}
                        onClick={onAddHandler}
                    >
                        {""}
                    </Button>
                )}
            </div>
            <div className={classesTasks.root}>
                <small>{tasks.length > 0 ? "Order" : "No tasks found"}</small>
                {tasks
                    .sort((a, b) => a.ordinal - b.ordinal)
                    .map((task) => (
                        <FlowTask
                            key={`task-${task.id}`}
                            task={task}
                            readOnly={readOnly}
                            onMouseOver={setOverTask}
                            isMouseOver={overTask && task.id === overTask.id}
                            onEdit={onEditHandler}
                            onView={onViewHandler}
                            onMoveUp={onMoveUpHandler}
                            onMoveDown={onMoveDownHandler}
                        />
                    ))}
            </div>
        </>
    );
}
